import { render, staticRenderFns } from "./booking-create-meta-v2.vue?vue&type=template&id=55f48a25&scoped=true&"
import script from "./booking-create-meta-v2.vue?vue&type=script&lang=js&"
export * from "./booking-create-meta-v2.vue?vue&type=script&lang=js&"
import style0 from "./booking-create-meta-v2.vue?vue&type=style&index=0&id=55f48a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f48a25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VContainer,VDatePicker,VDialog,VRow,VSpacer})
